import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const tokens = capitalDesignTokens.foundations.colors;
const capitalCategoricalPalette = [
  tokens.indigo600,
  tokens.terracotta600,
  tokens.jade600,
  tokens.magenta600,
  tokens.cerulean600,
  tokens.orange600,
  tokens.periwinkle600,
  tokens.rose600,
  tokens.port600,
  tokens.blue600,
  tokens.purple600
];
export {
  capitalCategoricalPalette
};
//# sourceMappingURL=capitalCategoricalPalette.js.map
